module.exports = __webpack_public_path__ + "f1df43982040e541ca856f6a7623f97c.png";